module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.loadingFresh),
      callback: function($$v) {
        _vm.loadingFresh = $$v
      },
      expression: "loadingFresh"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.noMore,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loadingMore),
      callback: function($$v) {
        _vm.loadingMore = $$v
      },
      expression: "loadingMore"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('van-cell', {
      key: item.id
    }, [_c('span', {
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }, [_c('p', [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.change > 0) ? _c('span', {
      staticClass: "list-right"
    }, [_vm._v("+" + _vm._s(item.change))]) : _c('span', {
      staticClass: "list-right"
    }, [_vm._v(_vm._s(item.change))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#969799"
      }
    }, [_vm._v(_vm._s(item.create_time_str) + " 当前积分 " + _vm._s(item.score))])])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-btn"
  }, [_c('div', {
    staticClass: "add-b-b"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("申请额外积分")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aeaa252","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailScore.vue
// module id = 2333
// module chunks = 0